import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconHook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconHook"><Circle cx="9.25" cy="5.75" r="3" stroke="currentColor" strokeWidth="1.5"/><Path d="M9.25 9V17.5C9.25 19.5711 10.9289 21.25 13 21.25C15.0711 21.25 16.75 19.5711 16.75 17.5V12L13.75 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconHook;
